import { MobileWorkerReportState } from '../types';

export const mobileWorkerReportsState: MobileWorkerReportState = {
  reports: [],
  hiddenReports: [],
  isRequestPending: false,
};
